// extracted by mini-css-extract-plugin
export default {"customBtn":"LoginForm_customBtn__ntHrB","pClr":"LoginForm_pClr__1ZTvu","chkBox":"LoginForm_chkBox__+y3x9"};